<template>
  <div class="patient-list">
    <div class="content-margin">
      <c-input placeholder="Cari" type="search" v-model="searchKeyword" />
    </div>
    <ul class="patient-list-wrap">
      <li
        class="patient-list-item"
        v-for="patient in filteredPatients"
        :key="patient.id"
        @click="showPatientDetail(parseInt(patient.id))"
      >
        <h4>{{ patient.fullname }}</h4>
        <p>{{ patient.department?.name }}</p>
      </li>
    </ul>
    <p align="center" v-if="filteredPatients.length == 0">
      Tidak ada data tersedia.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "patient-list",
  data: function () {
    return {
      searchKeyword: "",
    };
  },
  computed: {
    ...mapGetters({
      patients: "patients",
    }),
    filteredPatients: function () {
      if (this.patients.length > 0 && this.searchKeyword.length > 0) {
        return this.patients.filter((item) =>
          item.fullname.toLowerCase().includes(this.searchKeyword.toLowerCase())
        );
      }
      return this.patients;
    },
  },
  methods: {
    showPatientDetail: function (id) {
      this.$router.push({
        name: "patient-detail",
        params: { id },
      });
    },
  },
  created: function () {
    this.$store.dispatch("startPageLoading");
    this.$store
      .dispatch("getAllUser", "patient")
      .then(() => {
        this.$store.dispatch("stopPageLoading");
      })
      .catch(() => {
        this.$store.dispatch("stopPageLoading");
      });
  },
};
</script>
